// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1jEw0","content":"GlobalSearch_content__3Jm-g"};